module.exports = __webpack_public_path__ + "img/withdrawn.4f4c2aff.svg";